import { featuresData } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
            为什么选择我们
          </h2>
          <p className="text-foreground-500 text-base max-w-xl mx-auto">
            六大核心优势，为您的彩金体验保驾护航
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {featuresData.map((feature) => (
            <div
              key={feature.id}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-6 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}